/**
 * GPS機能を使用して現在地を取得し地図検索ページに遷移する
 * 取得失敗時はエラーページに遷移
 */
function getGPS(){
  var gps;
  try {
    if(typeof(navigator.geolocation) == 'undefined'){
      gps = google.gears.factory.create('beta.geolocation');
    } else {
      gps = navigator.geolocation;
    }
  } catch(e) {
    location.href = '/iphone/gps_err.html?code=0';
  }
  // オプション値設定(高精度OFF：タイムアウト10秒：キャッシュ利用しない)
  var option = { enableHighAccuracy: false, timeout : 10000, maximumAge: 0 };
  gps.getCurrentPosition(updatePosition, handleError , option);
  return false;
}

/**
 * GPS機能を使用して現在地を取得し地図を表示する
 * 取得失敗時はエラーページに遷移せず緯度経度指定無しで地図を表示
 */
function displayMap(){
  var gps;
  try {
    if(typeof(navigator.geolocation) == 'undefined'){
      gps = google.gears.factory.create('beta.geolocation');
    } else {
      gps = navigator.geolocation;
    }
  } catch(e) {
    location.href = '/iphone/map/search.php';
  }
  // オプション値設定(高精度OFF：タイムアウト10秒：キャッシュ利用しない)
  var option = { enableHighAccuracy: false, timeout : 10000, maximumAge: 0 };
  gps.getCurrentPosition(updatePosition, handleErrorForMap , option);
  return false;
}

/**
 * GPS取得成功時に緯度経度を使って地図検索ページに遷移する
 * @param {Object} position 位置情報オブジェクト
 */
function updatePosition(position) {
  var lat = position.coords.latitude;
  var lon = position.coords.longitude;
  //緯度経度の表示は、lat,lonのパラメータで検索となっているため、合わせるよう変更(set_dataの値は検索BOXに表示するため)
  location.href = '/iphone/map/search.php?lat=' + lat + '&lon=' + lon;
}
/**
 * GPS取得失敗時にエラーページに遷移する
 * @param {Object} positionError エラー情報オブジェクト
 */
function handleError(positionError) {
  location.href = '/iphone/gps_err.html';
  // エラーコード判別あり　デバッグ用
  //code = positionError.code;
  //location.href = '/iphone/gps_err.html?code=' + code;
}
/**
 * GPS取得失敗時に緯度経度指定無しで地図検索ページに遷移する
 * エラーページには遷移しない
 * @param {Object} positionError エラー情報オブジェクト
 */
function handleErrorForMap(positionError) {
  location.href = '/iphone/map/search.php';
}